var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashDeleteSharedClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D52C2C",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8025 11.4225C21.595 11.3025 20.3875 11.2125 19.1725 11.145V11.1375L19.0075 10.1625C18.895 9.4725 18.73 8.4375 16.975 8.4375H15.01C13.2625 8.4375 13.0975 9.4275 12.9775 10.155L12.82 11.115C12.1225 11.16 11.425 11.205 10.7275 11.2725L9.1975 11.4225C8.8825 11.4525 8.6575 11.73 8.6875 12.0375C8.7175 12.345 8.9875 12.57 9.3025 12.54L10.8325 12.39C14.7625 12 18.7225 12.15 22.6975 12.5475C22.72 12.5475 22.735 12.5475 22.7575 12.5475C23.0425 12.5475 23.29 12.33 23.32 12.0375C23.3425 11.73 23.1175 11.4525 22.8025 11.4225Z",
    fill: "#D52C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1015 13.0425C20.9215 12.855 20.674 12.75 20.419 12.75H10.939C10.684 12.75 10.429 12.855 10.2565 13.0425C10.084 13.23 9.98651 13.485 10.0015 13.7475L10.4665 21.4425C10.549 22.5825 10.654 24.0075 13.2715 24.0075H18.0865C20.704 24.0075 20.809 22.59 20.8915 21.4425L21.3565 13.755C21.3715 13.485 21.274 13.23 21.1015 13.0425ZM16.924 20.25H14.4265C14.119 20.25 13.864 19.995 13.864 19.6875C13.864 19.38 14.119 19.125 14.4265 19.125H16.924C17.2315 19.125 17.4865 19.38 17.4865 19.6875C17.4865 19.995 17.2315 20.25 16.924 20.25ZM17.554 17.25H13.804C13.4965 17.25 13.2415 16.995 13.2415 16.6875C13.2415 16.38 13.4965 16.125 13.804 16.125H17.554C17.8615 16.125 18.1165 16.38 18.1165 16.6875C18.1165 16.995 17.8615 17.25 17.554 17.25Z",
    fill: "#D52C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDeleteSharedClip);
export default __webpack_public_path__ + "static/media/trash-delete-shared-clip.a1bef672799d1e9ccc1981c0ac44c826.svg";
export { ForwardRef as ReactComponent };